var _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcMessage = function SvgIcMessage(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72673 6.95015C9.72673 7.21476 9.62162 7.46853 9.43451 7.65564C9.2474 7.84274 8.99363 7.94786 8.72902 7.94786H2.74274L0.747314 9.94329V1.96158C0.747314 1.69697 0.85243 1.4432 1.03954 1.25609C1.22665 1.06898 1.48042 0.963867 1.74503 0.963867H8.72902C8.99363 0.963867 9.2474 1.06898 9.43451 1.25609C9.62162 1.4432 9.72673 1.69697 9.72673 1.96158V6.95015Z",
    stroke: "white",
    strokeWidth: 1.06898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-message.63105f70.svg";
export { ForwardRef as ReactComponent };